module.exports = __webpack_public_path__ + "static/media/YELD.bcbf96e2.png";